'use client';

import { useDisclosure, useClickOutside } from '@mantine/hooks';
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

import Button from '@/components/Button';
import { useCartClient } from '@/components/Cart/hooks/useCartClient';
import IconButton from '@/components/IconButton';
import Loader from '@/components/Loader/Loader';
import { formatPrice } from '@/utils/helpers/formatPrice';
import cartIcon from 'public/icons/cart-icon.svg';
import closeIcon from 'public/icons/close.svg';

import SideCartItem from './SideCartItem/SideCartItem';
import styles from './styles.module.scss';

const SideCart = () => {
  const [opened, { toggle, close: handleClose }] = useDisclosure(false);
  const { cart } = useCartClient();
  const router = useRouter();

  const ref = useClickOutside(handleClose);

  const handleClick = () => {
    if (window.innerWidth < 1000) {
      router.push('/koszyk/');
    } else {
      toggle();
    }
  };

  return (
    <div ref={ref} className={styles.container}>
      <IconButton className={styles.cartBtn} onClick={handleClick}>
        <>
          <div className={styles.itemCounter}>
            {cart?.items.length ? cart?.items.length : '0'}
          </div>
          <Image src={cartIcon} alt="Ikona koszyka" height={20} width={20} />
          <p>Koszyk</p>
        </>
      </IconButton>
      <div
        className={cn(styles.expandedContainer, {
          [styles.opened]: opened,
        })}
      >
        {cart ? (
          <>
            <div className={styles.header}>
              <p className={styles.title}>Twój koszyk ({cart.items.length})</p>
              <Button
                onClick={handleClose}
                variant="icon"
                className={styles.closeBtn}
              >
                <Image
                  src={closeIcon}
                  alt="Ikona krzyżyka"
                  height={18}
                  width={18}
                />
              </Button>
            </div>
            <div className={styles.items}>
              {cart.items.length ? (
                cart.items.map(item => (
                  <SideCartItem item={item} key={item.id} />
                ))
              ) : (
                <p className={styles.emptyCartInfo}>Brak produktów w koszyku</p>
              )}
            </div>
            <div className={styles.footer}>
              {cart.items.length > 0 && (
                <div className={styles.total}>
                  <p>Razem</p>
                  <p>{formatPrice(cart.subtotal || 0)} PLN</p>
                </div>
              )}
              <Link href="/koszyk">
                <Button
                  onClick={handleClose}
                  fullWidth
                  variant="checkout"
                  className={styles.goToCart}
                >
                  IDŹ DO KOSZYKA
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};

export default SideCart;
